













import {Component, Prop} from "vue-property-decorator";
import abpbase from "@/lib/abpbase";
// import {routers} from '@/router/router';
import {EMPTY_ARRAY} from "@/lib/appconst";

@Component({name: 'sectionLayout'})
export default class sectionLayout extends abpbase {
    @Prop({type: String, default: ''}) title: string;

    mounted() {
    }
}
